export default {
	module: 'intercomAdmin',
	actions: {
		list: true,
		create: true,
		dynamicPaths: [
			{
				paths: {
					'/intercomAdmin/edit/:id': true,
				},
				keys: {
					':id': 3
				}
			}
		]
	}
}

